
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

interface SmartCardOption {
  value: string;
  label: string;
  description?: string;
}

@Component
export default class SmartCardMenu extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ type: Array, default: () => [] }) readonly options!: SmartCardOption[];
  @Prop({ type: String, default: null }) readonly selected!: string | null;
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop({ type: String, default: '' }) readonly title!: string;

  get menu(): boolean {
    return this.value;
  }

  set menu(val: boolean) {
    this.$emit('input', val);
  }

  onSelect(optionValue: string) {
    this.$emit('select', optionValue);
    this.menu = false;
  }

  onRefresh() {
    this.$emit('refresh');
  }
}
